import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useStoredThemes, useStoredThemesApi } from "../../context/StoredThemes.js";
import { ThemeChip } from "./ThemeChip.js";
import { useComputeThemes } from "./useComputeThemes.js";
import { useTexts } from "./useTexts.js";
function AdvancedThemeSettings(props) {
  const { onClose, texts: userTexts } = props;
  const { activeThemeName, themes: storedThemes } = useStoredThemes();
  const storedThemesApi = useStoredThemesApi();
  const storedTheme = storedThemes[activeThemeName] ?? {};
  const [themeName, setThemeName] = useState(activeThemeName);
  const saveDisabled = themeName.trim().length === 0 || themeName === activeThemeName;
  const themes = useComputeThemes(onClose);
  const texts = useTexts(userTexts);
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-testid": "advanced-settings-menu-root",
      sx: {
        bgcolor: "background.paper",
        width: "100%"
      },
      children: /* @__PURE__ */ jsxs(
        Box,
        {
          sx: {
            display: "grid",
            gridTemplateColumns: " auto 3fr",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ jsxs(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, padding: 3 }, children: [
              /* @__PURE__ */ jsx(Typography, { children: texts.title }),
              /* @__PURE__ */ jsx(
                TextField,
                {
                  label: "Theme name",
                  onChange: (e) => {
                    setThemeName(e.target.value);
                  },
                  sx: { width: 300 },
                  value: themeName
                }
              ),
              /* @__PURE__ */ jsx(
                TextField,
                {
                  disabled: true,
                  label: "Theme customization JSON",
                  multiline: true,
                  sx: { width: 300 },
                  type: "textarea",
                  value: JSON.stringify(storedTheme, null, 2)
                }
              ),
              /* @__PURE__ */ jsx(Box, { sx: { display: "flex" }, children: /* @__PURE__ */ jsx(
                Button,
                {
                  disabled: saveDisabled,
                  onClick: () => {
                    storedThemesApi.upSertTheme(themeName, storedTheme);
                  },
                  sx: { textTransform: "uppercase" },
                  variant: "contained",
                  children: texts.saveLabel
                }
              ) })
            ] }),
            /* @__PURE__ */ jsx(Box, { sx: { height: "100%" }, children: /* @__PURE__ */ jsxs(
              Box,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  height: "100%",
                  padding: 3
                },
                children: [
                  /* @__PURE__ */ jsx(Typography, { children: "Stored themes" }),
                  /* @__PURE__ */ jsx(Box, { sx: { display: "flex", flexWrap: "wrap", gap: 2 }, children: themes.map((theme) => /* @__PURE__ */ jsx(ThemeChip, { ...theme }, theme.name)) })
                ]
              }
            ) })
          ]
        }
      )
    }
  );
}
export {
  AdvancedThemeSettings
};
//# sourceMappingURL=AdvancedThemeSettings.js.map
